import { Box, Typography, Button, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DesktopWindowsIcon from "@mui/icons-material/DesktopWindows";

interface DesktopOnlyMessageProps {
  screenName?: string;
}

export const DesktopOnlyMessage = ({
  screenName = "This screen",
}: DesktopOnlyMessageProps) => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "70vh",
          textAlign: "center",
          gap: 3,
          p: 3,
        }}
      >
        {/* Desktop Icon */}
        <DesktopWindowsIcon
          sx={{
            fontSize: 80,
            color: "text.secondary",
            opacity: 0.5,
          }}
        />

        {/* Main Message */}
        <Typography variant="h5" fontWeight="medium" color="text.primary">
          Desktop Only
        </Typography>

        <Typography variant="body1" color="text.secondary">
          {screenName} is working properly only on desktop devices, and is
          currently unavailable in mobile.
        </Typography>

        {/* Helpful Text */}
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Please switch to a desktop device to access this feature.
        </Typography>

        {/* Back Button */}
        <Button
          variant="contained"
          color="secondary"
          onClick={() => navigate("/")}
          sx={{ mt: 2 }}
        >
          Back to Home
        </Button>
      </Box>
    </Container>
  );
};

export default DesktopOnlyMessage;
